const NAME = "ACCOUNT";
export const VALIDATECONTRACTNUMBER = `${NAME}/VALIDATECONTRACTNUMBER`;
export const VALIDATECONTRACTNUMBER_SUCCESS = `${NAME}/VALIDATECONTRACTNUMBER_SUCCESS`;
export const VALIDATECONTRACTNUMBER_FAILURE = `${NAME}/VALIDATECONTRACTNUMBER_FAILURE`;
export const LOGIN = `${NAME}/LOGIN`;
export const LOGIN_SUCCESS = `${NAME}/LOGIN_SUCCESS`;
export const LOGIN_FAILURE = `${NAME}/LOGIN_FAILURE`;
export const GET_COOKIE = `${NAME}/GET_COOKIE`;
export const GETACCOUNTID = `${NAME}/GETACCOUNTID`;
export const CLEARACCOUNTID = `${NAME}/CLEARACCOUNTID`;
export const CLEARJWTTOKEN = `${NAME}/CLEARJWTTOKEN`;
export const SETLOADER = `${NAME}/SETLOADER`;
export const ACCOUNT_USER_TOKEN = `${NAME}/ACCOUNT_USER_TOKEN`;
export const SET_REFRESH_TOKEN = `${NAME}/SET_REFRESH_TOKEN`;
export const SET_JWT_TOKEN = `${NAME}/SET_JWT_TOKEN`;
export const SET_SESSION_EXPIRED = `${NAME}/SESSION_EXPIRED`;
export const SET_LOGOUT = `${NAME}/LOGOUT`;
export const SET_REVEAL_SESSION_EXPIRED = `${NAME}/REVEAL_SESSION_EXPIRED`;
export const SET_FIRST_PAGE_LOADER = `${NAME}/SET_FIRST_PAGE_LOADER`;
export const RESET = `${NAME}/RESET`;
export const SET_TIMERS_RUNNING = `${NAME}/SET_TIMERS_RUNNING`;
export const GET_PERMISSION = `${NAME}/GET_PERMISSION`;
export const SET_PERMISSION = `${NAME}/SET_PERMISSION`;
export const SET_ACTIVE_COOKIE = `${NAME}/SET_ACTIVE_COOKIE`;
export const SET_REVEAL_PERMISSION_FALLBACK = `${NAME}/SET_REVEAL_PERMISSION_FALLBACK`;
export const SET_CASE_NUMBER_GLOBAL = `${NAME}/SET_CASE_NUMBER_GLOBAL`;
export const SET_FILE_TRYAGAIN_MODAL = "SET_FILE_TRYAGAIN_MODAL";
export const SET_FILE_TRYAGAIN_SUCCESS = "SET_FILE_TRYAGAIN_SUCCESS";
export const GET_BANNER_MESSAGE = "GET_BANNER_MESSAGE";
export const BANNER_MESSAGE = "BANNER_MESSAGE";
export const BANNER_DISPLAY_ON_LANDING = "BANNER_DISPLAY_ON_LANDING";
export const BANNER_DISPLAY_ON_ALL = "BANNER_DISPLAY_ON_ALL";
export const GET_PLANNED_MAINTENANCE = "GET_PLANNED_MAINTENANCE";
export const SET_PLANNED_MAINTENANCE = "SET_PLANNED_MAINTENANCE";
export const DISPLAY_PLANNED_MAINTENANCE = "DISPLAY_PLANNED_MAINTENANCE";
export const SET_WINDOW_WIDTH_HEIGHT = "SET_WINDOW_WIDTH_HEIGHT";
export const GET_WINDOW_WIDTH_HEIGHT = "GET_WINDOW_WIDTH_HEIGHT";
export const GET_CONTRACT_NUMBERS = `${NAME}/GET_CONTRACT_NUMBERS`;
export const GET_CONTRACT_NUMBERS_SUCCESS = `${NAME}/GET_CONTRACT_NUMBERS_SUCCESS`;
export const GET_CONTRACT_NUMBERS_FAILURE = `${NAME}/GET_CONTRACT_NUMBERS_FAILURE`;
export const SET_SECOND_PAGE = `${NAME}/SET_SECOND_PAGE`;
export const SET_ENCRYPT_ID = `${NAME}/SET_ENCRYPT_ID`;
export const SET_CONTRACT_ACCOUNT_COUNTRY = `${NAME}/SET_CONTRACT_ACCOUNT_COUNTRY`;
export const GET_PAYMENT_STATUS = `${NAME}/GET_PAYMENT_STATUS`;
export const GET_PAYMENT_STATUS_SUCCESS = `${NAME}/GET_PAYMENT_STATUS_SUCCESS`;
export const GET_PAYMENT_STATUS_FAILURE = `${NAME}/GET_PAYMENT_STATUS_FAILURE`;
export const SET_HEADER_ARIA_HIDDEN = "SET_HEADER_ARIA_HIDDEN";
export const SET_PREFERRED_SELECTED_DATE = "SET_PREFERRED_SELECTED_DATE";

export const login = (callback) => {
  return {
    type: LOGIN,
    callback,
  };
};
export const loginSuccess = () => {
  return {
    type: LOGIN_SUCCESS,
  };
};
export const loginFailure = (error) => {
  return {
    type: LOGIN_FAILURE,
    error,
  };
};
export const getAccountUserToken = (accountUserTokenDetails) => {
  return {
    type: ACCOUNT_USER_TOKEN,
    accountUserTokenDetails,
  };
};
export const getCookie = (cookie) => {
  return {
    type: GET_COOKIE,
    cookie,
  };
};
export const clearAccountId = () => {
  return {
    type: CLEARACCOUNTID,
  };
};
export const clearJwtToken = () => {
  return {
    type: CLEARJWTTOKEN,
  };
};
export const setLoader = (value) => {
  return {
    type: SETLOADER,
    value,
  };
};
export const getAccount_Id = (account_id) => {
  return {
    type: GETACCOUNTID,
    account_id,
  };
};

export const getValidateContract = (accountNumber, contractNumber, userId, callback) => {
  return {
    type: VALIDATECONTRACTNUMBER,
    accountNumber,
    contractNumber,
    userId,
    callback,
  };
};

export const getValidateContractSuccess = (data) => {
  return {
    type: VALIDATECONTRACTNUMBER_SUCCESS,
    data,
  };
};

export const getValidateContractFailure = (error) => {
  return {
    type: VALIDATECONTRACTNUMBER_FAILURE,
    error,
  };
};

export const setRefreshToken = (data) => {
  return {
    type: SET_REFRESH_TOKEN,
    data,
  };
};
export const setJwtToken = (jwtToken) => {
  return {
    type: SET_JWT_TOKEN,
    jwtToken,
  };
};

export const setSessionExpired = (sessionExpired) => {
  return {
    type: SET_SESSION_EXPIRED,
    sessionExpired,
  };
};

export const setLogout = (data) => {
  return {
    type: SET_LOGOUT,
    data,
  };
};

export const setRevealSessionExpired = (sessionExpired) => {
  return {
    type: SET_REVEAL_SESSION_EXPIRED,
    sessionExpired,
  };
};

export const setFirstPageLoader = (data) => {
  return {
    type: SET_FIRST_PAGE_LOADER,
    data,
  };
};

export const setTimersRunning = (timerStatus) => {
  return {
    type: SET_TIMERS_RUNNING,
    timerStatus,
  };
};

export const setActiveCookie = (value) => {
  return {
    type: SET_ACTIVE_COOKIE,
    value,
  };
};

export const setRevealPermissionFallBack = (value) => {
  return {
    type: SET_REVEAL_PERMISSION_FALLBACK,
    value,
  };
};

export const reset = () => {
  return {
    type: RESET,
  };
};

export const getPermission = (callback, loginResponseData) => {
  return {
    type: GET_PERMISSION,
    callback,
    loginResponseData,
  };
};

export const setCaseNumberGlobal = (value) => {
  return {
    type: SET_CASE_NUMBER_GLOBAL,
    value,
  };
};

export function setFileTryAgainModal(value) {
  return {
    type: SET_FILE_TRYAGAIN_MODAL,
    value,
  };
}

export function setFileTryAgainSuccess(value) {
  return {
    type: SET_FILE_TRYAGAIN_SUCCESS,
    value,
  };
}

export const setPermission = (name, value) => {
  return {
    type: SET_PERMISSION,
    name,
    value,
  };
};
export const getBannerMessage = () => {
  return {
    type: GET_BANNER_MESSAGE,
  };
};
export const getPlannedMaintenance = () => {
  return {
    type: GET_PLANNED_MAINTENANCE,
  };
};
export const setBannerMessage = (value) => {
  return {
    type: BANNER_MESSAGE,
    value,
  };
};

export const setPlannedMaintenance = (value) => {
  return {
    type: SET_PLANNED_MAINTENANCE,
    value,
  };
};
export const setBannerDisplayOnLanding = (value) => {
  return {
    type: BANNER_DISPLAY_ON_LANDING,
    value,
  };
};
export const setBannerDisplayOnAll = (value) => {
  return {
    type: BANNER_DISPLAY_ON_ALL,
    value,
  };
};
export const setDisplayPlannedMaintenance = (value) => {
  return {
    type: DISPLAY_PLANNED_MAINTENANCE,
    value,
  };
};
export const setwindowWidthHeight = (value) => {
  return {
    type: SET_WINDOW_WIDTH_HEIGHT,
    value,
  };
};
export const getwindowWidthHeight = () => {
  return {
    type: GET_WINDOW_WIDTH_HEIGHT,
  };
};
export const getContractNumbers = (accountNumber, userId, callback, timer) => {
  return {
    type: GET_CONTRACT_NUMBERS,
    accountNumber,
    userId,
    callback,
    timer,
  };
};

export const getContractNumbersSuccess = (data) => {
  return {
    type: GET_CONTRACT_NUMBERS_SUCCESS,
    data,
  };
};

export const getContractNumbersFailure = (error) => {
  return {
    type: GET_CONTRACT_NUMBERS_FAILURE,
    error,
  };
};
export const setSecondPage = (showValue, enableValue) => {
  return {
    type: SET_SECOND_PAGE,
    showValue,
    enableValue,
  };
};
export const setEncryptId = (encryptValue) => {
  return {
    type: SET_ENCRYPT_ID,
    encryptValue,
  };
};
export const setContractAccountCountry = (contractAccountCountry) => {
  return {
    type: SET_CONTRACT_ACCOUNT_COUNTRY,
    contractAccountCountry,
  };
};
//START - REDBALL CONFIG
export const getPaymentStatus = (paymentStatusPayload, callback) => {
  return {
    type: GET_PAYMENT_STATUS,
    paymentStatusPayload,
    callback,
  };
};
//END - REDBALL CONFIG
export const getPaymentStatusSuccess = (data) => {
  return {
    type: GET_PAYMENT_STATUS_SUCCESS,
    data,
  };
};

export const getPaymentStatusFailure = (error) => {
  return {
    type: GET_PAYMENT_STATUS_FAILURE,
    error,
  };
};

export const setHeaderAriaHidden = (val) => {
  return {
    type: SET_HEADER_ARIA_HIDDEN,
    val,
  };
};
export const setPreferredSelectedDate = (val) => {
  return {
    type: SET_PREFERRED_SELECTED_DATE,
    val,
  };
};
